<div *ngIf="plan" class="summary">
  <ng-container *ngIf="plan !== BookingPlans.Trial; else trialPackageSummary">
    <ng-container
      *ngIf="bookingStore.selectedInstallationsCount$ | async as installationsCount; else emptyCart"
    >
      <ng-container>
        <h3 class="summary-title">
          {{ '+BOOKING.SUMMARY.SHOPPING_CART' | translate }}
        </h3>
        <div class="summary-cart">
          <ng-container
            *ngIf="
              bookingStore.subscriptionsDetails$ | async as subscriptionsDetails;
              else preliminaryPrice
            "
          >
            <div *ngFor="let item of subscriptionsDetails.items" class="cart-entry">
              <span [attr.data-at-selected-package]="item.name"> {{ item.name }}</span>
              <span
                [attr.data-at-selected-devices-amount]="item.quantity"
                [attr.data-at-package-price]="item.price"
                >{{ item.quantity }}x{{ item.price }}
                {{ subscriptionsDetails.price.currency }}</span
              >
            </div>
          </ng-container>
          <ng-template #preliminaryPrice>
            <ng-container *ngIf="selectedInstallationsQuantityAndPrice">
              <!-- Selected E3 installations -->
              <div
                class="cart-entry"
                *ngIf="selectedInstallationsQuantityAndPrice.e3Devices.length as e3DevicesLength"
              >
                <ng-container *ngIf="plan === BookingPlans.Pro">
                  <span [attr.data-at-selected-package]="plan">{{
                    '+BOOKING.SUMMARY.PLAN.PRO' | translate
                  }}</span>
                  <span
                    [attr.data-at-selected-devices-amount]="e3DevicesLength"
                    [attr.data-at-package-price]="bookingPlans.pro.price.price"
                  >
                    {{ e3DevicesLength }} x
                    {{ bookingPlans.pro.price.price | number: '1.2-2':'de-DE' }}
                    {{ bookingPlans.pro.price.currency }}</span
                  >
                </ng-container>
                <ng-container *ngIf="plan === BookingPlans.Plus">
                  <span [attr.data-at-selected-package]="plan">{{
                    '+BOOKING.SUMMARY.PLAN.PLUS' | translate
                  }}</span>
                  <span
                    [attr.data-at-selected-devices-amount]="e3DevicesLength"
                    [attr.data-at-package-price]="bookingPlans.plus.price.price"
                  >
                    {{ e3DevicesLength }} x
                    {{ bookingPlans.plus.price.price | number: '1.2-2':'de-DE' }}
                    {{ bookingPlans.plus.price.currency }}</span
                  >
                </ng-container>
              </div>
              <!-- Selected legacy installations -->
              <div
                class="cart-entry"
                *ngIf="
                  selectedInstallationsQuantityAndPrice.legacyDevices.length as legacyDevicesLength
                "
              >
                <ng-container *ngIf="plan === BookingPlans.Pro">
                  <span data-at-selected-package="Pro">
                    {{ '+BOOKING.SUMMARY.PLAN.PRO_LEGACY' | translate }}</span
                  >
                  <span
                    [attr.data-at-selected-devices-amount]="legacyDevicesLength"
                    [attr.data-at-package-price]="bookingPlans.proLegacy.price.price"
                    >{{ legacyDevicesLength }} x
                    {{ bookingPlans.proLegacy.price.price | number: '1.2-2':'de-DE' }}
                    {{ bookingPlans.proLegacy.price.currency }}</span
                  >
                </ng-container>
                <ng-container *ngIf="plan === BookingPlans.Plus">
                  <span data-at-selected-package="Plus">
                    {{ '+BOOKING.SUMMARY.PLAN.PLUS_LEGACY' | translate }}</span
                  >
                  <span
                    [attr.data-at-selected-devices-amount]="legacyDevicesLength"
                    [attr.data-at-package-price]="bookingPlans.plusLegacy.price.price"
                    >{{ legacyDevicesLength }} x
                    {{ bookingPlans.plusLegacy.price.price | number: '1.2-2':'de-DE' }}
                    {{ bookingPlans.plusLegacy.price.currency }}</span
                  >
                </ng-container>
              </div>
            </ng-container>
          </ng-template>
        </div>
        <div
          *ngIf="(bookingStore.subscriptionsDetails$ | async)?.price as price"
          class="summary-discounts"
        >
          <div class="discounts-entry">
            <span>{{ '+BOOKING.PRICE.TOTAL' | translate }}</span
            ><span data-at-net-price class="discounts-entry-price"
              >{{ price.net.toFixed(2) }} {{ price.currency }}</span
            >
          </div>
          <div class="discounts-entry">
            <span>{{ '+BOOKING.PRICE.TAX_RATE' | translate: { taxRate: price.taxRate } }}</span
            ><span data-at-tax class="discounts-entry-price"
              >{{ price.tax.toFixed(2) | number: '1.2-2':'de-DE' }} {{ price.currency }}</span
            >
          </div>
        </div>

        <div class="summary-br"></div>
        <div
          *ngIf="(bookingStore.subscriptionsDetails$ | async)?.price as price; else netPrice"
          class="summary-total-price"
          data-at-final-price
        >
          {{ price.total.toFixed(2) | number: '1.2-2':'de-DE' }} {{ price.currency }}
        </div>
        <ng-template #netPrice>
          <div class="summary-total-price" data-at-net-price>
            {{ finalPrice }}
          </div>
        </ng-template>

        <div class="summary-tos" *ngIf="isCheckout && document">
          <mat-checkbox
            data-at-terms-of-use-checkbox
            gtm="onToggle"
            gtmAction="Booking Checkout"
            gtmCategory="booking"
            [(ngModel)]="tosAccepted"
            (ngModelChange)="onTosCheckboxChange($event)"
          >
          </mat-checkbox>
          <span
            data-at-terms-of-use-link
            [innerHTML]="
              '+BOOKING.SUMMARY_USER_AGGREEMENT.TEXT'
                | translate
                | link: '{key}':'+BOOKING.SUMMARY_USER_AGGREEMENT.KEY_TRANSLATION':document.link
            "
          ></span>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
  <button
    data-at-checkout-button
    *ngIf="plan !== BookingPlans.Trial; else testNowButton"
    gtm="onGoToPage"
    gtmAction="Booking Checkout"
    gtmCategory="booking"
    class="summary-btn-continue"
    [disabled]="isContinueDisabled() || !(bookingStore.loaded$ | async)"
    mat-raised-button
    color="primary"
    (click)="onContinue()"
  >
    <span *ngIf="!isCheckout">{{ '+BOOKING.SUMMARY.BTN.CONTINUE' | translate }}</span>
    <span *ngIf="isCheckout">{{ '+BOOKING.SUMMARY.BTN.SUBSCRIBE' | translate }}</span>
  </button>

  <ng-template #testNowButton>
    <button
      data-at-test-now-button
      gtm="onGoToPage"
      gtmAction="Trial confirmation page"
      gtmCategory="booking"
      class="summary-btn-continue"
      [disabled]="isContinueDisabled()"
      mat-raised-button
      color="primary"
      (click)="onConfirmTrialVersion()"
    >
      {{ '+BOOKING.SUMMARY.BTN.TEST_NOW' | translate }}
    </button>
  </ng-template>

  <ng-template #emptyCart>
    <h3 class="summary-title">
      {{ '+BOOKING.SUMMARY_EMPTY_CART.TITLE' | translate }}
    </h3>
    <div class="summary-description">
      {{ '+BOOKING.SUMMARY_EMPTY_CART.DESCRIPTION' | translate }}
    </div>
  </ng-template>

  <ng-template #trialPackageSummary>
    <h3 class="summary-title">
      {{ '+BOOKING.SUMMARY_TRIAL_PACKAGE.TITLE' | translate }}
    </h3>
    <div class="summary-description">
      {{ '+BOOKING.SUMMARY_TRIAL_PACKAGE.DESCRIPTION' | translate }}
    </div>
  </ng-template>
</div>
